export const initialState = {
  loading: false,
  users: {},
  apiStatus: { loader: false, message: "", data: "" },
};
